<template>
  <div id="app">
    <HeaderBar />
    <price-table 
      :isVisible="isPriceTableVisible" 
      @close="closePriceTable" 
    />
    <main class="main-content">
      <router-view @show-price-table="showPriceTable"></router-view>
    </main>
    <FooterBar />
  </div>
</template>

<script>
import HeaderBar from './components/HeaderBar.vue'
import FooterBar from './components/FooterBar.vue'
import PriceTable from './components/PriceTable.vue'

export default {
  name: 'App',
  components: {
    HeaderBar,
    FooterBar,
    PriceTable
  },
  data() {
    return {
      isPriceTableVisible: false
    }
  },
  methods: {
    showPriceTable() {
      this.isPriceTableVisible = true
    },
    closePriceTable() {
      this.isPriceTableVisible = false
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  margin-top: 0px; /* 为固定的header留出空间 */
  flex: 1;
  background-color: rgb(254, 247, 245);
  padding: 2rem 0;
}
</style>
